<h1 class="webapp-title">{{cardInfo.title}}</h1>
<div class="card-top-image">
    <div class="card-image">
      <img [src]="cardInfo.imageUrl" alt="" class="card-big-footer-image">
    </div>
    <div class="card-footer card-big-footer">

      <h2 *ngIf="cardInfo.subtitle" class="webapp-title-secondary">{{cardInfo.subtitle}}</h2>
      <app-smart-paragraph *ngIf="cardInfo.shortPara" [text]="cardInfo.shortPara" [limit]="120"></app-smart-paragraph>
      <app-smart-paragraph *ngIf="cardInfo.longPar" [text]="cardInfo.longPar" [limit]="280"></app-smart-paragraph>
      <div class="info-block rounded" *ngIf="cardInfo.description">
          <div class="info-block-icon"><mat-icon>info</mat-icon></div>
          <p>{{cardInfo.description}}</p>
      </div>
      <span *ngFor="let obj of cardInfo.array">
        <h2 class="webapp-title-secondary">{{obj[cardInfo['fieldForTitle']]}}</h2>
          <app-smart-paragraph [text]="obj[cardInfo['fieldForContent']]" [limit]="180"></app-smart-paragraph>
      </span>

    <!-- <a href="/single/" class="button button-fill button-round color-dark">
      Read More
      <i class="icon f7-icons">arrow_right</i>
    </a> -->
    </div>
</div>